import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import { Alert, Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';

import style from '../../styles/layout.module.css';
import request from '../../utils/useAxios';


const SortOtherModel = ({ openModal = false, setOpenModel = () => {} }) => {
  const [others, setOthers] = useState([]);
  const sortOthers = useRef([]);

  const getAllOtherList = useCallback(async () => {
    const res = await request({
      data: {
        order: '',
        order_by: '',
        page: 0,
        page_size: 0,
        type: 0,
      },
      method: 'post',
      url: '/Backend/Cafe_MealOthMenu/list ',
    });
    if (res.code === 200) {
      return (res.result.datas || []).map((data, index) => {
        return {
          index: index + 1,
          ...data,
        };
      });
    } else {
      return [];
    }
  }, []);

  const sortOtherList = useCallback(async others => {
    const res = await request({
      data: others.map((other, index) => {
        return {
          id: other.id,
          sort: index,
        };
      }),
      method: 'post',
      url: '/Backend/Cafe_MealOthMenu/sort',
    });
    if (res.code === 200) {
      toast.success('修改完成');
      return res;
    } else {
      toast.success('修改失敗');
      throw res;
    }
  }, []);

  const handleOnDragEnd = result => {
    const { source, destination } = result;
    if (!destination) {
      return;
    }
    const [remove] = sortOthers.current.splice(source.index, 1);
    sortOthers.current.splice(destination.index, 0, remove);
    setOthers(sortOthers.current);
  };

  useEffect(() => {
    if (openModal) {
      getAllOtherList().then(others => {
        setOthers(others);
        sortOthers.current = [...others];
      });
    }
  }, [openModal, getAllOtherList, setOthers]);

  return (
    <div className={style.modal}>
      <Modal
        centered
        size="lg"
        isOpen={openModal}
        toggle={() => {
          sortOtherList(others).then(() => {
            setOpenModel(false);
          });
        }}
        backdrop="static"
      >
        <ModalHeader
          className={style.modal_head}
          toggle={() => {
            sortOtherList(others).then(() => {
              setOpenModel(false);
            });
          }}
        >
          咖啡選單排序
        </ModalHeader>
        <ModalBody>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="brands">
              {provided => (
                <ul
                  className="drag_list"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {others.map((other, index) => (
                    <Draggable
                      key={other.id}
                      draggableId={`${other.id}`}
                      index={index}
                    >
                      {provided => (
                        <li
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <Alert color="warning" className="d-flex p-0 w-100">
                            <Badge className="d-flex align-items-center">
                              {other.index}
                            </Badge>
                            <div className="p-3">{other.name}</div>
                          </Alert>
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default memo(SortOtherModel);
